import { Component, OnInit, AfterViewInit, ViewChild, Input, QueryList, ViewChildren } from '@angular/core';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { ActivitiHandlerService } from '../common/services/activitiHandler.service';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    templateUrl: './nonStp.template.html',
    styleUrls: ['./nonStp.style.scss']
})
export class NonStpComponent implements OnInit, AfterViewInit {
    @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
    public ContentPopup;
    public NonstpPopUpData;
    nextTaskKey: string;
    constructor(private _activitiHandler: ActivitiHandlerService,
        private _routerService: RouteHandlerService) { }
    public ngOnInit() {
        this.initNonstpModal();
        this.getDetails();
    }
    public ngAfterViewInit() {
        this.ShowChildModal(this.NonstpPopUpData.Id);
    }
    /*Initializee Non stp Popup*/
    private initNonstpModal() {
        this.NonstpPopUpData = {
            Id: 'nonstp-modal',
            Title: 'Premium Info',
            Config: <CustomModalOptions>{ show: false, closeOption: true, backdrop: 'static' }
        };
        console.log('this.config.closeOption:', this.NonstpPopUpData.Config.closeOption);
    }
    // Show Modal Popup
    public ShowChildModal(id: string, contentType?: string): void {
        if (contentType) {
            this.initNonstpModal();
        }
        this.getModalDirectiveInstanceBasedOnId(id).show();
    }
    // Hide Modal Popup
    public HideChildModal(id: string): void {
        this.getModalDirectiveInstanceBasedOnId(id).hide();
    }
    /* Getting Popup Instances Based on Id */
    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        return this.PopupComponent.filter((item: PopupComponent, index: number) => {
            return item.id === popupId;
        })[0].modalControl;
    }
    public hideChildNonstpPopUpModal(): void {
        this.getModalDirectiveInstanceBasedOnId(this.NonstpPopUpData.Id).hide();
        // this.authenticateUser();
    }
    public reject() {
        this.markTaskComplete(null, 'Ok');
    }
    public continueToJourney() {
        this.markTaskComplete(null, null);
    }
    // Mark Task As Completed Activiti Call
    private markTaskComplete(data: any, actionName: string) {
        this._activitiHandler.MarkTaskAsCompleted(data, actionName, false).subscribe(
            (mtResponse: ActivitiModel.MTResponse<null>) => {
                if (!mtResponse.errorBean) {
                    this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
                }
            });
    }
    private getDetails() {
        this._activitiHandler.GetTaskDetails().subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
            if (!mtResponse.errorBean) {
                this.nextTaskKey = mtResponse.nextTaskKey;
            }
        });
    }
}
